"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NON_CA_ROLES = exports.CAS_ROLES = exports.CA_ROLES = exports.RoleDefinitions = exports.Roles = void 0;
var Roles;
(function (Roles) {
    Roles["AGENT"] = "AGENT";
    Roles["ASSESSOR"] = "ASSESSOR";
    Roles["AUTHOR"] = "AUTHOR";
    Roles["CANDIDATE"] = "CANDIDATE";
    Roles["CHECKPOINT_ADMIN"] = "CHECKPOINT_ADMIN";
    Roles["CPSQ_ADMIN"] = "CPSQ_ADMIN";
    Roles["DELEGATED_ADMIN"] = "DELEGATED_ADMIN";
    Roles["EXAMINER"] = "EXAMINER";
    Roles["EXAMS_OFFICER"] = "EXAMS_OFFICER";
    Roles["INTERNAL_ADMIN"] = "INTERNAL_ADMIN";
    Roles["INTERNAL_COMPLIANCE"] = "INTERNAL_COMPLIANCE";
    Roles["INTERNAL_HELPDESK"] = "INTERNAL_HELPDESK";
    Roles["INTERNAL_MODERATOR"] = "INTERNAL_MODERATOR";
    Roles["INTERNAL_OPERATIONS"] = "INTERNAL_OPERATIONS";
    Roles["LEARNER"] = "LEARNER";
    Roles["MODERATOR"] = "MODERATOR";
    Roles["ORGANISATION_ADMIN"] = "ORGANISATION_ADMIN";
    Roles["ORGANISATION_COMPLIANCE"] = "ORGANISATION_COMPLIANCE";
    Roles["ORGANIZATION_APPROVER"] = "ORGANIZATION_APPROVER";
    Roles["PARENT"] = "PARENT";
    Roles["POLICY_APPROVER"] = "POLICY_APPROVER";
    Roles["SUBMIT_ADMINISTRATOR"] = "SUBMIT_ADMINISTRATOR";
    Roles["SUBMIT_COMPLIANCE"] = "SUBMIT_COMPLIANCE";
    Roles["SUBMIT_EXAMS_OFFICER"] = "SUBMIT_EXAMS_OFFICER";
    Roles["SUBMIT_HELPDESK"] = "SUBMIT_HELPDESK";
    Roles["SUBMIT_INTERNAL_ASSESSMENT_MANAGER"] = "SUBMIT_INTERNAL_ASSESSMENT_MANAGER";
    Roles["SUBMIT_INTERNAL_MODERATOR"] = "SUBMIT_INTERNAL_MODERATOR";
    Roles["SUBMIT_MODERATOR"] = "SUBMIT_MODERATOR";
    Roles["SUBMIT_TEACHER"] = "SUBMIT_TEACHER";
    Roles["SUPERVISOR"] = "SUPERVISOR";
    Roles["TEACHER"] = "TEACHER";
    Roles["TEACH_CAMBRIDGE_PUBLISHER"] = "TEACH_CAMBRIDGE_PUBLISHER";
    Roles["TEACH_CAMBRIDGE_EDITOR"] = "TEACH_CAMBRIDGE_EDITOR";
    Roles["TEACH_CAMBRIDGE_ADMIN_VIEWER"] = "TEACH_CAMBRIDGE_ADMIN_VIEWER";
})(Roles = exports.Roles || (exports.Roles = {}));
exports.RoleDefinitions = (_a = {},
    _a[Roles.AGENT] = {
        description: 'An Agent is an individual or organisation who run and administer tests and can also resell tests.',
        alias: 'Agent',
    },
    _a[Roles.ASSESSOR] = {
        description: 'An Assessor represents Cambridge and provides quality assurance of the assessment processes that an awarding body, school, college, university or training organisation use.',
        alias: 'Assessor',
    },
    _a[Roles.AUTHOR] = {
        description: 'An Author (Assessment) is an individual who produces assessment items and related mark scheme/answer keys and appropriate assessment grids.',
        alias: 'Author',
    },
    _a[Roles.CANDIDATE] = {
        description: 'A Candidate is an individual who sits a test.',
        alias: 'Candidate',
    },
    _a[Roles.CHECKPOINT_ADMIN] = {
        description: 'Role to access and run reports in the Checkpoint Reporting service.',
        alias: 'Checkpoint Admin',
    },
    _a[Roles.CPSQ_ADMIN] = {
        description: 'For users that administer the Cambridge Personal Styles Questionnaire.',
        alias: 'CPSQ Admin',
    },
    _a[Roles.DELEGATED_ADMIN] = {
        description: 'User management will give permission to perform activities for other users such as: invite them to your organisation, apply roles, reset passwords etc.',
        alias: 'User Management',
    },
    _a[Roles.EXAMINER] = {
        description: 'An Examiner is involved in preparing for and completing the standardisation process, marking candidates’ work, providing reports and providing post-results support for reviews or appeals.',
        alias: 'Examiner',
    },
    _a[Roles.EXAMS_OFFICER] = {
        description: 'An Exams Officer will administer, manage and conduct examinations. Exams office staff support teaching colleagues and students.',
        alias: 'Exams Officer',
    },
    _a[Roles.INTERNAL_ADMIN] = {
        description: 'An internal user that administers one or more services.',
        alias: 'Internal Admin',
    },
    _a[Roles.INTERNAL_COMPLIANCE] = {
        description: 'Provide operational and/or statutory compliance management for a service or platform.',
        alias: 'Internal Compliance',
    },
    _a[Roles.INTERNAL_HELPDESK] = {
        description: 'The helpdesk role may be used for providing customer or user support.',
        alias: 'Internal Helpdesk',
    },
    _a[Roles.INTERNAL_MODERATOR] = {
        description: 'The internal moderator is a Cambridge staff member involved in  reviewing a candidates’ work according to the marking criteria/assessment requirements and ensure it has been accurately marked.',
        alias: 'Internal Moderator',
    },
    _a[Roles.INTERNAL_OPERATIONS] = {
        description: 'A person from a Cambridge operations team that may perform tasks such as setting up content, or configuation or support for external and internal users.',
        alias: 'Internal Operations',
    },
    _a[Roles.LEARNER] = {
        description: 'A person that engages with our products and services for the purpose of learning, this could be a student, an exam taker or someone purchasing learning materials.',
        alias: 'Learner',
    },
    _a[Roles.MODERATOR] = {
        description: 'The moderator will review a candidates’ work according to the marking criteria/assessment requirements and ensure it has been accurately marked.',
        alias: 'Moderator',
    },
    _a[Roles.ORGANISATION_ADMIN] = {
        description: 'An individual who will manage the administrative activities relating to Cambridge products and services.',
        alias: 'Administrator',
    },
    _a[Roles.ORGANISATION_COMPLIANCE] = {
        description: 'An individual who is a member of an organisation and may be required to provide operational, HR and statutory compliance management for the organisation.',
        alias: 'Compliance Officer',
    },
    _a[Roles.PARENT] = {
        description: "A Parent or Guardian is someone that may want to access services on behalf of their children or monitor their children's activities. They may also be able to add or remove child relationships to their account.",
        alias: 'Parent',
    },
    _a[Roles.SUBMIT_ADMINISTRATOR] = {
        description: 'Internal role for administering series and component business rules, and tracking submissions in Submit for Assessment.',
        alias: 'Submit for Assessment: Administrator',
    },
    _a[Roles.SUBMIT_COMPLIANCE] = {
        description: 'Internal role for administering and tracking malpractice checks automated within Submit for Assessment.',
        alias: 'Submit for Assessment: Compliance Officer',
    },
    _a[Roles.SUBMIT_EXAMS_OFFICER] = {
        description: 'For submitting both examined candidate work, and moderated marks and samples, within Submit for Assessment. Receives all system notifications.',
        alias: 'Submit for Assessment: Exams Officer',
    },
    _a[Roles.SUBMIT_HELPDESK] = {
        description: 'Internal role for providing support to customers using Submit for Assessment.',
        alias: 'Submit for Assessment: Customer Services Advisor',
    },
    _a[Roles.SUBMIT_INTERNAL_ASSESSMENT_MANAGER] = {
        description: 'Internal role for read access of series and component business rules, and tracking submissions in Submit for Assessment.',
        alias: 'Submit for Assessment: Assessment Manager',
    },
    _a[Roles.SUBMIT_INTERNAL_MODERATOR] = {
        description: 'Internal role for mirroring Centre access within Submit for Assessment.',
        alias: 'Submit for Assessment: Internal Moderator',
    },
    _a[Roles.SUBMIT_MODERATOR] = {
        description: 'Assessor role for accessing moderated marks and samples submitted within Submit for Assessment.',
        alias: 'Submit for Assessment: Moderator',
    },
    _a[Roles.SUBMIT_TEACHER] = {
        description: 'The Teacher role is  for submitting both examined candidate work, and moderated marks and samples, within Submit for Assessment. Receives system notifications for submissions they undertake.',
        alias: 'Submit for Assessment: Teacher',
    },
    _a[Roles.SUPERVISOR] = {
        description: 'A person that will be involved in the supervision of exams sessions or candidates.',
        alias: 'Supervisor',
    },
    _a[Roles.TEACHER] = {
        description: 'A teacher will be someone that supports the learning of students or learners and will need to access materials and content relating to the subjects they teach.',
        alias: 'Teacher',
    },
    _a[Roles.TEACH_CAMBRIDGE_ADMIN_VIEWER] = {
        description: 'Gives users access to view content on Teach Cambridge in preview mode so that content can be viewed and checked before publishing to external users.',
        alias: 'Teach Cambridge Admin: Viewer',
    },
    _a[Roles.TEACH_CAMBRIDGE_EDITOR] = {
        description: 'Gives users access to create and manage content on the Teach Cambridge site. It does not provide publishing rights.',
        alias: 'Teach Cambridge Admin: Editor',
    },
    _a[Roles.TEACH_CAMBRIDGE_PUBLISHER] = {
        description: 'Gives users full access to Teach Cambridge Admin to manage content, publish content, and configure the structure of the Teach Cambridge site.',
        alias: 'Teach Cambridge Admin: Publisher',
    },
    _a);
exports.CA_ROLES = [
    Roles.ASSESSOR,
    Roles.AUTHOR,
    Roles.CHECKPOINT_ADMIN,
    Roles.EXAMINER,
    Roles.INTERNAL_ADMIN,
    Roles.INTERNAL_COMPLIANCE,
    Roles.INTERNAL_HELPDESK,
    Roles.INTERNAL_MODERATOR,
    Roles.INTERNAL_OPERATIONS,
    Roles.MODERATOR,
    Roles.SUBMIT_ADMINISTRATOR,
    Roles.SUBMIT_COMPLIANCE,
    Roles.SUBMIT_HELPDESK,
    Roles.SUBMIT_INTERNAL_MODERATOR,
    Roles.SUBMIT_INTERNAL_ASSESSMENT_MANAGER,
    Roles.SUBMIT_MODERATOR,
    Roles.TEACH_CAMBRIDGE_ADMIN_VIEWER,
    Roles.TEACH_CAMBRIDGE_EDITOR,
    Roles.TEACH_CAMBRIDGE_PUBLISHER,
];
exports.CAS_ROLES = [
    Roles.ASSESSOR,
    Roles.AUTHOR,
    Roles.EXAMINER,
    Roles.MODERATOR,
    Roles.SUBMIT_MODERATOR,
    Roles.DELEGATED_ADMIN,
];
exports.NON_CA_ROLES = [
    Roles.CPSQ_ADMIN,
    Roles.DELEGATED_ADMIN,
    Roles.EXAMS_OFFICER,
    Roles.ORGANISATION_ADMIN,
    Roles.ORGANISATION_COMPLIANCE,
    Roles.SUBMIT_EXAMS_OFFICER,
    Roles.SUBMIT_TEACHER,
    Roles.SUPERVISOR,
    Roles.TEACHER,
];
